import { useEffect, useRef } from "react";

const stats = [
  { value: "2", label: "Partnerzy" },
  { value: "100+", label: "Agencji w sieci" },
  { value: "3+", label: "Eventy rocznie" },
];

export default function MHHero() {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      el.style.opacity = "0";
      el.style.transform = "translateY(30px)";
      setTimeout(() => {
        el.style.transition = "opacity 0.8s ease, transform 0.8s ease";
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      }, 150);
    }
  }, []);

  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://i.imgur.com/yQH9c3H.jpg"
          alt="Meet Hiszpania"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/20" />
      </div>

      <div ref={contentRef} className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pb-20 pt-40">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12" style={{ backgroundColor: "#CC1F1A" }} />
            <span className="text-sm font-semibold uppercase tracking-widest" style={{ color: "#CC1F1A" }}>
              Platforma B2B
            </span>
          </div>

          <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-6 uppercase tracking-tight">
            Łączymy<br />
            <span style={{ color: "#FFD100" }}>Polskę</span>{" "}
            <span className="text-white">z</span>{" "}
            <span style={{ color: "#FFD100" }}>Hiszpanią</span>
          </h1>

          <p className="text-lg text-white/80 max-w-xl leading-relaxed mb-10">
            Przestrzeń networkingowa dla touroperatorów i agencji turystycznych —
            starannie wybrani partnerzy i ekskluzywne eventy B2B w Polsce.
          </p>

          <div className="flex flex-wrap gap-4 mb-16">
            <button
              onClick={() => document.querySelector("#partners")?.scrollIntoView({ behavior: "smooth" })}
              className="px-7 py-3.5 font-bold text-sm uppercase tracking-widest text-white rounded-lg transition-all cursor-pointer whitespace-nowrap hover:opacity-90"
              style={{ backgroundColor: "#CC1F1A" }}
            >
              Poznaj partnerów
            </button>
            <button
              onClick={() => document.querySelector("#events")?.scrollIntoView({ behavior: "smooth" })}
              className="px-7 py-3.5 font-bold text-sm uppercase tracking-widest text-white rounded-lg border border-white/40 hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
            >
              Wydarzenia 2026
            </button>
          </div>

          <div className="flex flex-wrap gap-10">
            {stats.map((s) => (
              <div key={s.label}>
                <p className="text-4xl font-extrabold text-white">{s.value}</p>
                <p className="text-xs uppercase tracking-widest text-white/60 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
